// @ts-check

/**
 * @typedef RouteListItem
 * @property {string} id
 * @property {string} path
 * @property {string} name
 * @property {boolean} [isPublic=false]
 */

/** @type {Record<string, RouteListItem>} */
export const routesList = {
	home: {
		id: "home",
		path: "/",
		name: "Inicio",
		isPublic: true,
	},

	register: {
		id: "register",
		path: "/register",
		name: "Registro",
		isPublic: true,
	},
	login: {
		id: "login",
		path: "/login",
		name: "Iniciar sesión",
		isPublic: true,
	},
	logout: {
		id: "logout",
		path: "/logout",
		name: "Cerrar sesión",
		isPublic: true,
	},
	repair: {
		id: "repair",
		path: "/repair",
		name: "Reparar aplicación",
		isPublic: true,
	},
	magicLink: {
		id: "magicLink",
		path: "/magicLink",
		name: "Magic link",
		isPublic: true,
	},

	crewInvitation: {
		id: "crewInvitation",
		path: "/crew-invitation",
		name: "Invitación a grupo",
	},

	// Apps
	items: {
		id: "items",
		path: "/items",
		name: "Items",
	},

	economos: {
		id: "economos",
		path: "/economos",
		name: "Inicio",
	},
	economosMovements: {
		id: "economosMovements",
		path: "/economos/movements",
		name: "Movimientos",
	},
	economosSearch: {
		id: "economosSearch",
		path: "/economos/search",
		name: "Buscar movimientos",
	},
	economosAnalysis: {
		id: "economosAnalysis",
		path: "/economos/analysis",
		name: "Analizar movimientos",
	},

	mementos: {
		id: "mementos",
		path: "/mementos",
		name: "Mementos",
	},

	split: {
		id: "split",
		path: "/split",
		name: "Split",
	},
	splitGroup: {
		id: "splitGroup",
		path: "/split/:shortId",
		name: "Grupo Split",
	},

	// Onboarding
	onboardingGroup: {
		id: "onboardingGroup",
		path: "/onboarding/group",
		name: "Grupo",
	},

	// Settings
	settings: {
		id: "settings",
		path: "/settings",
		name: "Ajustes",
	},

	// Other
	healbot: {
		id: "healbot",
		path: "/healbot",
		name: "Heal bot",
		isPublic: true,
	},
};

/**
 *
 * @param {string} path
 * @returns {boolean}
 */
export function isPublicPath(path) {
	for (const _key in routesList) {
		const route = routesList[_key];

		if (route.path === path) {
			return Boolean(route.isPublic);
		}
	}

	return false;
}
